"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var colors_1 = require("../../constants/colors");
var get_1 = __importDefault(require("lodash/get"));
var utils_1 = require("../../utils");
var Container = styled_components_1.default.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  height: 40px;\n  align-items: center;\n  padding: 0;\n  width: 100%;\n\n  .c-axs-tab {\n    color: ", ";\n    background-color: ", ";\n    cursor: pointer;\n    border-bottom: ", ";\n    border-top: ", ";\n    border-right: ", ";\n    display: inline-block;\n    height: 40px;\n    line-height: 38px;\n    padding: 0 16px 6px;\n    font-size: ", ";\n    font-weight: bold;\n    text-align: center;\n    text-transform: uppercase;\n    width: 100%;\n    vertical-align: middle;\n\n    &:first-of-type {\n    border-left: ", ";\n      border-top-left-radius: 4px;\n      border-bottom-left-radius: 4px;\n    }\n\n    &:last-of-type {\n      border-top-right-radius: 4px;\n      border-bottom-right-radius: 4px;\n    }\n  }\n\n  .c-axs-tab--active {\n    color: ", ";\n    background-color: ", ";\n"], ["\n  display: flex;\n  height: 40px;\n  align-items: center;\n  padding: 0;\n  width: 100%;\n\n  .c-axs-tab {\n    color: ",
    ";\n    background-color: ",
    ";\n    cursor: pointer;\n    border-bottom: ",
    ";\n    border-top: ",
    ";\n    border-right: ",
    ";\n    display: inline-block;\n    height: 40px;\n    line-height: 38px;\n    padding: 0 16px 6px;\n    font-size: ", ";\n    font-weight: bold;\n    text-align: center;\n    text-transform: uppercase;\n    width: 100%;\n    vertical-align: middle;\n\n    &:first-of-type {\n    border-left: ",
    ";\n      border-top-left-radius: 4px;\n      border-bottom-left-radius: 4px;\n    }\n\n    &:last-of-type {\n      border-top-right-radius: 4px;\n      border-bottom-right-radius: 4px;\n    }\n  }\n\n  .c-axs-tab--active {\n    color: ", ";\n    background-color: ",
    ";\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return utils_1.parseThemePath(color, theme, colors_1.colors.GREY_650);
}, function (_a) {
    var backgroundColor = _a.backgroundColor, theme = _a.theme;
    return utils_1.parseThemePath(backgroundColor, theme, colors_1.colors.WHITE);
}, function (_a) {
    var borderColor = _a.borderColor, theme = _a.theme;
    return "2px solid " + utils_1.parseThemePath(borderColor, theme, colors_1.colors.BLUE_300);
}, function (_a) {
    var borderColor = _a.borderColor, theme = _a.theme;
    return "2px solid " + utils_1.parseThemePath(borderColor, theme, colors_1.colors.BLUE_300);
}, function (_a) {
    var borderColor = _a.borderColor, theme = _a.theme;
    return "2px solid " + utils_1.parseThemePath(borderColor, theme, colors_1.colors.BLUE_300);
}, function (_a) {
    var fontSize = _a.fontSize, theme = _a.theme;
    return get_1.default(theme, fontSize, '12px');
}, function (_a) {
    var borderColor = _a.borderColor, theme = _a.theme;
    return "2px solid " + utils_1.parseThemePath(borderColor, theme, colors_1.colors.BLUE_300);
}, function (_a) {
    var colorActive = _a.colorActive, theme = _a.theme;
    return utils_1.parseThemePath(colorActive, theme, colors_1.colors.WHITE);
}, function (_a) {
    var backgroundColorActive = _a.backgroundColorActive, theme = _a.theme;
    return utils_1.parseThemePath(backgroundColorActive, theme, colors_1.colors.BLUE_300);
});
var AXSTabs = function (props) {
    var newChildren = React.Children.map(props.children, function (child) {
        return React.cloneElement(child, {
            handleMenuClick: props.handleMenuClick ? props.handleMenuClick : function () {
            },
            tabWidth: props.tabWidth,
        });
    });
    return (React.createElement(Container, __assign({ role: "menubar" }, props, { className: classnames_1.default(['c-axs-tabs', props.className]) }), newChildren));
};
AXSTabs.defaultProps = {
    backgroundColor: 'axsui.components.tabs.backgroundColor',
    backgroundColorActive: 'axsui.components.tabs.backgroundColorActive',
    borderColor: 'axsui.components.tabs.borderColor',
    borderColorActive: 'axsui.components.tabs.borderColorActive',
    color: 'axsui.components.tabs.color',
    colorActive: 'axsui.components.tabs.colorActive',
    fluid: false,
    horizontal: false,
    menuAlign: 'left',
};
exports.default = AXSTabs;
var templateObject_1;
//# sourceMappingURL=index.js.map